import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/wmai.png";
import {AiOutlineMenu, AiOutlineClose} from 'react-icons/ai'

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mobileNav, setMobileNav] = useState(true);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleMobileNav = () => {
    setMobileNav(!mobileNav);
  };

  return (
    <>
      <nav className="fixed top-0 left-0 w-full text-white bg-lightblack border-b-2 border-yellow z-10">
        <div className="container hidden md:flex mx-auto px-4 py-2 flex items-center justify-between">
          <button
            className={`font-bold ${
              isOpen ? "translate-x-0" : "translate-x-full"
            } transition-transform ease-in-out duration-500`}
            onClick={toggleDropdown}
          >
            <div>Menu</div>
            <img src={logo} alt="logo" width={75} />
          </button>
          <ul className={`ml-4 flex ${isOpen ? "block" : "hidden"}`}>
            <li className="py-1">
              <NavLink
                to="/"
                className="block hover:text-yellow active:bg-yellow focus:text-gray font-bold px-2"
              >
                Home
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="/instructors"
                className="block hover:text-yellow focus:text-gray px-2"
              >
                Instructors
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="/schedule"
                className="block hover:text-yellow focus:text-gray px-2"
              >
                Schedule
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="/location"
                className="block hover:text-yellow focus:text-gray px-2"
              >
                Location
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="/pricing"
                className="block hover:text-yellow focus:text-gray px-2"
              >
                Pricing
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="/contact"
                className="block hover:text-yellow focus:text-gray px-2"
              >
                Contact Us
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="https://zenkofightwear.com/collections/westmore-bjj"
                className="block hover:text-yellow px-2"
                target="_blank"
              >
                Fightwear
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="https://westmorebjj.myshopify.com/"
                className="block hover:text-yellow px-2"
                target="_blank"
              >
                Apparel
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="https://westmorebjj.gymdesk.com/login"
                className="block hover:text-yellow px-2"
                target="_blank"
              >
                Login
              </NavLink>
            </li>
            <li className="py-1 font-bold pr-4">
              <NavLink
                to="https://westmorebjj.gymdesk.com/signup/v/6Xnpq"
                className="block hover:text-yellow px-2"
                target="_blank"
              >
                Waiver
              </NavLink>
            </li>
            <li className="py-1 font-bold">
              <NavLink
                to="https://westmorebjj.gymdesk.com/signup"
                className="text-center rounded-full bg-red block px-2 w-24"
                target="_blank"
              >
                Sign Up!
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="fixed right-0 top-0 p-4 block md:hidden" onClick={handleMobileNav}>
          {!mobileNav ? <AiOutlineClose size={30} /> : <AiOutlineMenu size={30} />}
        </div>
        <div className={!mobileNav ? 'fixed left-0 top-0 bg-lightblack border-2 border-yellow w-[50%] h-full ease-in-out duration-500 block md:hidden' : 'fixed left-[-100%]'}>
          <img src={logo} alt="logo" width={75} className="mx-auto my-4" />
          <ul>
          <li className="p-4 font-bold">
              <NavLink
                to="/"
                className="block hover:text-yellow active:bg-yellow focus:text-gray px-2"
                onClick={handleMobileNav}
              >
                Home
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="/instructors"
                className="block hover:text-yellow focus:text-gray px-2"
                onClick={handleMobileNav}
              >
                Instructors
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="/schedule"
                className="block hover:text-yellow focus:text-gray px-2"
                onClick={handleMobileNav}
              >
                Schedule
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="/location"
                className="block hover:text-yellow focus:text-gray px-2"
                onClick={handleMobileNav}
              >
                Location
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="/pricing"
                className="block hover:text-yellow focus:text-gray px-2"
                onClick={handleMobileNav}
              >
                Pricing
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="/contact"
                className="block hover:text-yellow focus:text-gray px-2"
                onClick={handleMobileNav}
              >
                Contact Us
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="https://zenkofightwear.com/collections/westmore-bjj"
                className="block hover:text-yellow px-2"
                target="_blank"
              >
                Fightwear
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="https://westmorebjj.myshopify.com/"
                className="block hover:text-yellow px-2"
                target="_blank"
              >
                Apparel
              </NavLink>
            </li>
            <li className="p-4 font-bold pr-4">
              <NavLink
                to="https://westmorebjj.gymdesk.com/login"
                className="block hover:text-yellow px-2"
                target="_blank"
              >
                Login
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="https://westmorebjj.gymdesk.com/signup/v/6Xnpq"
                className="block hover:text-yellow px-2"
                target="_blank"
              >
                Waiver
              </NavLink>
            </li>
            <li className="p-4 font-bold">
              <NavLink
                to="https://westmorebjj.gymdesk.com/signup"
                className="text-center rounded-full bg-red block px-2 w-24"
                target="_blank"
                onClick={handleMobileNav}
              >
                Sign Up!
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Nav;
